import type { ReasoningUIPart } from "ai";
import { Brain, Loader2 } from "lucide-react";

/**
 * Renders an assistant `reasoning` part as a lightweight "thinking" indicator.
 *
 * Reasoning models (the interviewer and chat both default to `gpt-6-luna`) emit
 * reasoning before and between tool calls and text. The SDK streams those
 * parts to the client by default (`toUIMessageStreamResponse` →
 * `sendReasoning: true`), but without a renderer the assistant bubble sits
 * empty during a long think — which reads as "frozen" on heavy turns.
 *
 * We deliberately do NOT surface the chain-of-thought text; only an animated
 * indicator while the model is reasoning. Once the part settles, the real
 * content (text/tool calls) takes over and this collapses to nothing.
 */
export function ReasoningView({ part }: { part: ReasoningUIPart }) {
  if (part.state !== "streaming") return null;
  return (
    <div className="my-1 flex items-center gap-1.5 text-[11px] text-muted-foreground">
      <Brain className="h-3 w-3 shrink-0" />
      <span className="font-medium">Thinking…</span>
      <Loader2 className="h-3 w-3 shrink-0 animate-spin" />
    </div>
  );
}
